const collators = new Map<string, Intl.Collator>();

function tagCollator(language: string): Intl.Collator {
  let collator = collators.get(language);
  if (!collator) {
    collator = new Intl.Collator(language, { numeric: true, sensitivity: "base" });
    collators.set(language, collator);
  }
  return collator;
}

export function compareTags(left: unknown, right: unknown, language = "de"): number {
  return tagCollator(language).compare(String(left ?? "").trim(), String(right ?? "").trim());
}

export function compareTaggedLabels(
  left: { tag?: string; name?: string },
  right: { tag?: string; name?: string },
  language = "de",
): number {
  return (
    compareTags(left.tag, right.tag, language) ||
    tagCollator(language).compare(String(left.name ?? "").trim(), String(right.name ?? "").trim())
  );
}
